import _ from 'lodash'

export default [
    {
        path: '/auth',
        component: require('../components/the-layout-card').default,
        children: [
            {
                name: 'auth.email-verifications.create',
                path: 'email-verifications/new',
                component: require('../views/auth/email-verifications/create').default
            },
            {
                name: 'auth.landlords.create',
                path: 'landlords/new',
                components: {
                    default: require('../views/auth/landlords/create').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: {
                                        name: 'auth.personas.create',
                                        query: _.get(this.$route, 'query')
                                    }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                'Not a landlord? ',
                                createElement('span', { class: 'text-blue' }, 'Swap')
                            ])
                        }
                    }
                }
            },
            {
                name: 'auth.password-resets.create',
                path: 'password-resets/new',
                component: require('../views/auth/password-resets/create').default
            },
            {
                name: 'auth.password-resets.edit',
                path: 'password-resets/:token',
                component: require('../views/auth/password-resets/edit').default
            },
            {
                name: 'auth.personas.index',
                path: 'profiles',
                components: {
                    default: require('../views/auth/personas/index').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: {
                                        name: 'auth.personas.create',
                                        query: _.get(this.$route, 'query')
                                    }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                'Need another profile? ',
                                createElement('span', { class: 'text-blue' }, 'Create one')
                            ])
                        }
                    }
                }
            },
            {
                name: 'auth.personas.create',
                path: 'profiles/new',
                components: {
                    default: require('../views/auth/personas/create').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: {
                                        name: 'auth.personas.index',
                                        query: _.get(this.$route, 'query')
                                    }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                'Already have a profile? ',
                                createElement('span', { class: 'text-blue' }, 'Select it')
                            ])
                        }
                    }
                }
            },
            {
                name: 'auth.sessions.create',
                path: 'login',
                components: {
                    default: require('../views/auth/sessions/create').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: {
                                        name: 'auth.users.create',
                                        query: _.get(this.$route, 'query')
                                    }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                "Don't have an account? ",
                                createElement('span', { class: 'text-blue' }, 'Create one')
                            ])
                        }
                    }
                }
            },
            {
                name: 'auth.telephone-verifications.show',
                path: 'telephone-verifications/:token',
                component: require('../views/auth/telephone-verifications/show').default
            },
            {
                name: 'auth.tenants.create',
                path: 'tenants/new',
                components: {
                    default: require('../views/auth/tenants/create').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: {
                                        name: 'auth.personas.create',
                                        query: _.get(this.$route, 'query')
                                    }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                'Not a tenant? ',
                                createElement('span', { class: 'text-blue' }, 'Swap')
                            ])
                        }
                    }
                }
            },
            {
                name: 'auth.users.create',
                path: 'create-account',
                components: {
                    default: require('../views/auth/users/create').default,
                    below: {
                        render (createElement) {
                            return createElement('router-link', {
                                attrs: {
                                    to: {
                                        name: 'auth.sessions.create',
                                        query: _.get(this.$route, 'query')
                                    }
                                },
                                class: 'text-center no-underline text-grey-darker'
                            }, [
                                'Already have an account? ',
                                createElement('span', { class: 'text-blue' }, 'Login')
                            ])
                        }
                    }
                }
            }
        ]
    }
]
